import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Upload,
} from "antd";
import "antd/dist/antd.css";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { EditFilled, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import {
  createLoaiyeucau,
  createLoaiyeucauFormURL,
  editLoaiyeucauURL,
  getLoaiyeucauFormURL,
  listBophanxuly,
  listLoaiyeucauall,
  updateLoaiyeucauFormURL,
  userIDURL,
} from "../constants";
import { authAxios } from "../utils";
import { openNotificationWithIcon } from "./Function";
import Cookies from "universal-cookie";
import CreateTable from "./component/CreateTable_LoaiYeuCau";
import PlusCircleTwoTone from "@ant-design/icons/lib/icons/PlusCircleTwoTone";

const cookies = new Cookies();

const { Search } = Input;

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
const timeout = (delay) => {
  return new Promise((res) => setTimeout(res, delay));
};
const fetchLoaiyeucauInfo = (Id) => {
  return authAxios(cookies.get("token")).get(editLoaiyeucauURL(Id));
};

const CreateInfo = (
  newData,
  dataLoaiYeuCau,
  listBophanxuly,
  resultData,
  dataUser,
) => {
  const normalizedNewName = (newData.tenyeucau || "").trim().toLowerCase();
  var getFilterData = dataLoaiYeuCau.filter(
    (item) =>
      item.handling_group === newData.bophanxuly &&
      (item.name || "").trim().toLowerCase() === normalizedNewName,
  );
  if (getFilterData.length > 0) {
    openNotificationWithIcon(
      "error",
      "Cảnh báo",
      "Trùng tên yêu cầu đã có trong bộ phận xử lý. Yêu cầu kiểm tra lại tên yêu cầu.",
    );
    return false;
  }
  if (
    newData.filedinhkemkhac &&
    newData.filedinhkemkhac.file.originFileObj.type !== "application/pdf"
  ) {
    openNotificationWithIcon("error", "Cảnh báo", "Chỉ được up file pdf");
    return false;
  }

  var FormData = require("form-data");
  var data = new FormData();
  data.append("name", newData.tenyeucau);
  data.append("is_active", newData.is_active);
  data.append(
    "attachment_file",
    newData.filedinhkemkhac ? newData.filedinhkemkhac.file.originFileObj : "",
  );
  data.append("handling_group", newData.bophanxuly);
  data.append(
    "handling_group_name",
    listBophanxuly
      .filter((item) => item.id === newData.bophanxuly)
      .map((value) => value.name)[0],
  );

  return authAxios(cookies.get("token"))
    .post(createLoaiyeucau, data)
    .then((res) => {
      if (res.data.message) {
        openNotificationWithIcon("error", "Lỗi", res.data.message);
        return false;
      }
      if (res.data.error) {
        const dataError = Object.entries(res.data.error).map(([key, value]) => (
          <p>{value}</p>
        ));
        openNotificationWithIcon("error", "Lỗi", dataError);
        return false;
      }
      var elementsErr = document.getElementsByClassName(
        "ant-form-item-explain-error",
      );
      if (elementsErr.length !== 0) {
        // console.log(elementsErr);
        return false;
      }
      timeout(500);
      if (Object.entries(resultData.forms).length > 0) {
        authAxios(cookies.get("token"))
          .post(createLoaiyeucauFormURL, {
            ticket_type: res.data.id,
            data_form: resultData,
            user: dataUser[0],
            mota: "auto",
            ghichu: "auto",
          })
          .then((res1) => {
            return true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    })
    .catch((err) => {
      console.log(err);
      return false;
    });
};

const editInfo = (
  newData,
  dataOld,
  dataLoaiYeuCau,
  listBophanxuly,
  resultData,
  dataUser,
  isEditingExistingForm,
) => {
  const normalizedNewName = (newData.tenyeucau || "").trim().toLowerCase();
  var getFilterData = dataLoaiYeuCau
    .filter((item) => item.id !== dataOld.id)
    .filter(
      (item) =>
        item.handling_group === newData.bophanxuly &&
        (item.name || "").trim().toLowerCase() === normalizedNewName,
    );
  if (getFilterData.length > 0) {
    openNotificationWithIcon(
      "error",
      "Cảnh báo",
      "Trùng tên yêu cầu đã có trong bộ phận xử lý. Yêu cầu kiểm tra lại tên yêu cầu.",
    );
    return false;
  }
  if (
    newData.filedinhkemkhac &&
    newData.filedinhkemkhac.file.originFileObj.type !== "application/pdf"
  ) {
    openNotificationWithIcon("error", "Cảnh báo", "Chỉ được up file pdf");
    return false;
  }

  var FormData = require("form-data");
  var data = new FormData();
  data.append("name", newData.tenyeucau);
  data.append(
    "attachment_file",
    newData.filedinhkemkhac ? newData.filedinhkemkhac.file.originFileObj : "",
  );
  data.append("handling_group", newData.bophanxuly);
  data.append(
    "handling_group_name",
    listBophanxuly
      .filter((item) => item.id === newData.bophanxuly)
      .map((value) => value.name)[0],
  );
  data.append("is_active", newData.is_active);

  return authAxios(cookies.get("token"))
    .put(editLoaiyeucauURL(dataOld.id), data)
    .then((res) => {
      if (res.data.error) {
        const dataError = Object.entries(res.data.error).map(([key, value]) => (
          <p>{value}</p>
        ));
        openNotificationWithIcon("error", "Lỗi", dataError);
        return false;
      }
      timeout(500);
      if (Object.entries(resultData).length > 0) {
        // Nếu đang cập nhật form đã tồn tại → dùng PUT /template_form/{id}
        // Nếu tạo mới form → dùng POST /template_form/
        const formRequest = isEditingExistingForm
          ? authAxios(cookies.get("token")).put(
              updateLoaiyeucauFormURL(dataOld.id),
              {
                ticket_type: res.data.id,
                data_form: resultData,
                user: dataUser[0],
                mota: "auto",
                ghichu: "auto",
              },
            )
          : authAxios(cookies.get("token")).post(createLoaiyeucauFormURL, {
              ticket_type: res.data.id,
              data_form: resultData,
              user: dataUser[0],
              mota: "auto",
              ghichu: "auto",
            });

        formRequest
          .then((res1) => {
            return true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    })
    .catch((err) => {
      openNotificationWithIcon("error", "Lỗi", err);
      return false;
    });
};

async function waitForLoaiyeucauInfo(Id) {
  let getLoaiyeucauInfo = await fetchLoaiyeucauInfo(Id);
  return getLoaiyeucauInfo;
}
async function waitForeditInfo(
  newData,
  dataOld,
  dataLoaiYeuCau,
  listBophanxuly,
  resultData,
  dataUser,
  isEditingExistingForm,
) {
  let res = await editInfo(
    newData,
    dataOld,
    dataLoaiYeuCau,
    listBophanxuly,
    resultData,
    dataUser,
    isEditingExistingForm,
  );
  return res;
}

async function waitForCreateInfo(
  newData,
  dataLoaiYeuCau,
  listBophanxuly,
  resultData,
  dataUser,
) {
  let res = await CreateInfo(
    newData,
    dataLoaiYeuCau,
    listBophanxuly,
    resultData,
    dataUser,
  );
  return res;
}
const cleanFormData = (forms) => {
  if (!forms || !Array.isArray(forms)) return forms;

  return forms.map((group) => ({
    ...group,
    children: (group.children || []).map((child) => {
      // 1. Clean title: trim and remove (*)
      const cleanTitle = (child.title || "")
        .replace(/\s*\(\*\)\s*/g, "")
        .trim();

      // 2. Clean validate: trim target and remove (*) if exists
      let cleanValidate = child.validate;
      if (cleanValidate && typeof cleanValidate === "object") {
        cleanValidate = { ...cleanValidate };
        if (cleanValidate.target) {
          cleanValidate.target = cleanValidate.target
            .replace(/\s*\(\*\)\s*/g, "")
            .trim();
        }
      }

      // 3. Clean options: flatten if needed
      let normalizedOption = child.option;
      if (Array.isArray(normalizedOption)) {
        normalizedOption = normalizedOption
          .map((v) => (Array.isArray(v) ? v[1] : v))
          .filter((v) => v !== undefined && v !== "");
      }

      const updatedChild = {
        ...child,
        title: cleanTitle,
        validate: cleanValidate,
      };

      if (Array.isArray(normalizedOption) && normalizedOption.length > 0) {
        updatedChild.option = normalizedOption;
      } else {
        delete updatedChild.option;
      }

      return updatedChild;
    }),
  }));
};

const useResetFormOnCloseModal = ({ form, visible }) => {
  const prevVisibleRef = useRef();
  useEffect(() => {
    prevVisibleRef.current = visible;
  }, [visible]);
  const prevVisible = prevVisibleRef.current;
  useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields();
    }
  }, [visible]);
};

const currentColumnsView = [
  {
    title: "STT",
    dataIndex: "id",
    key: "index",
    render: (value, item, index) => index + 1,
    width: 40,
  },
  {
    title: "Tiêu đề",
    dataIndex: "title",
    key: "title",
    type: "text",
    editable: true,
    color: "red",
    width: 200,
    render: (value, item) => {
      const base = (value || "").replace(" (*)", "");
      return item.required === true ? `${base} (*)` : base;
    },
  },
  {
    title: "Trường bắt buộc",
    dataIndex: "required",
    key: "required",
    type: "checkbox",
    editable: true,
    width: 50,
    render: (value, item, index) =>
      value == true ? <p style={{ color: "red" }}>*</p> : "",
  },
  {
    title: "Cho phép thay đổi",
    dataIndex: "handling",
    key: "handling",
    type: "checkbox",
    editable: true,
    width: 50,
    render: (value, item, index) =>
      value == true ? <p style={{ color: "red" }}>*</p> : "",
  },
  {
    title: "Kiểu dữ liệu",
    dataIndex: "type",
    key: "type",
    type: "select",
    editable: true,
    width: 80,
  },
  {
    title: "Tạo tùy chọn",
    dataIndex: "option",
    key: "option",
    type: "createoption",
    editable: true,

    width: 120,
    render: (value, item, index) => {
      if (!value || value.length === 0) return "";

      const normalizedValue = Array.isArray(value)
        ? value
            .map((v) => (Array.isArray(v) ? v[1] : v))
            .filter((v) => v !== undefined && v !== "")
        : [];

      if (normalizedValue.length === 0) return "";

      if (normalizedValue.length === 1) {
        return <Tag>{normalizedValue[0]}</Tag>;
      }

      const menu = (
        <Menu>
          {normalizedValue.map((v, i) => (
            <Menu.Item key={i}>{v}</Menu.Item>
          ))}
        </Menu>
      );

      return (
        <Dropdown placement="bottomCenter" overlay={menu}>
          <Tag style={{ cursor: "pointer" }}>
            {normalizedValue[0]} +{normalizedValue.length - 1} ...
          </Tag>
        </Dropdown>
      );
    },
  },
  {
    title: "Độ rộng cột (pixel)",
    dataIndex: "widthcol",
    key: "widthcol",
    type: "widthcol",
    editable: true,
    width: 60,
  },
  {
    title: (
      <Tooltip title="Chỉ hiển thị đối với người tạo và người xử lý ticket">
        <span>Hiển thị xử lý</span>
      </Tooltip>
    ),
    dataIndex: "status",
    key: "status",
    type: "checkbox",
    editable: true,
    width: 60,
    render: (value, item, index) =>
      value == true ? <p style={{ color: "red" }}>*</p> : "",
  },
  {
    title: "Cấu hình Validate",
    dataIndex: "validate",
    key: "validate",
    type: "text",
    editable: true,
    width: 150,
    render: (value) => {
      if (!value) return "";
      return (
        <Tag color="blue">
          {typeof value === "object" ? "Đã cấu hình" : "Cấu hình (...)"}
        </Tag>
      );
    },
  },
];

const currentColumnsCreate = [
  {
    title: "STT",
    dataIndex: "id",
    key: "index",
    render: (value, item, index) => index + 1,
    width: 40,
  },
  {
    title: "Tiêu đề",
    dataIndex: "title",
    key: "title",
    type: "text",
    editable: true,
    width: 200,
    render: (value, item) => {
      const base = (value || "").replace(" (*)", "");
      return item.required === true ||
        item.required === "true" ||
        (Array.isArray(item.required) && item.required[0] === "true")
        ? `${base} (*)`
        : base;
    },
  },
  {
    title: "Trường bắt buộc",
    dataIndex: "required",
    key: "required",
    type: "checkbox",
    editable: true,
    width: 50,
  },
  {
    title: "Cho phép thay đổi",
    dataIndex: "handling",
    key: "handling",
    type: "checkbox",
    editable: true,
    width: 50,
  },
  {
    title: "Kiểu dữ liệu",
    dataIndex: "type",
    key: "type",
    type: "select",
    editable: true,
    width: 80,
  },
  {
    title: "Tạo tùy chọn",
    dataIndex: "option",
    key: "option",
    type: "createoption",
    editable: true,
    width: 120,
  },
  {
    title: "Độ rộng cột (pixel)",
    dataIndex: "widthcol",
    key: "widthcol",
    type: "widthcol",
    editable: true,
    width: 60,
  },
  {
    title: (
      <Tooltip title="Chỉ hiển thị đối với người tạo và người xử lý ticket">
        <span>Hiển thị xử lý</span>
      </Tooltip>
    ),
    dataIndex: "status",
    key: "status",
    type: "checkbox",
    editable: true,
    width: 60,
  },
  {
    title: "Cấu hình Validate",
    dataIndex: "validate",
    key: "validate",
    type: "text",
    editable: true,
    width: 150,
    render: (value) => {
      if (!value) return "";
      return <Tag color="blue">Cấu hình (...)</Tag>;
    },
  },
];

const ModalFormCreate = ({ visible, onCancel, listBophanxuly, dataUser }) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  // const [currentColumns, setCurrentColumns] = useState([])
  const [currentDataSource, setcurrentDataSource] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [checkData, setCheckData] = useState(true);
  const [checkEmpty, setCheckEmpty] = useState(true);
  const [lsGroupHeader, setLsGroupHeader] = useState([]);
  const [selectedFileOtherList, setSelectedFileOtherList] = useState([]);
  const [selectedFileOther, setSelectedFileOther] = useState(null);

  useResetFormOnCloseModal({
    form,
    visible,
  });

  useEffect(() => {
    setCheckData(true);
    setResultData([]);
  }, [visible]);

  const onFinish = (values) => {
    // console.log(values)
    if (resultData.length === 0 && lsGroupHeader.length > 0 && !checkEmpty) {
      openNotificationWithIcon("error", "Lỗi", "Vui lòng nhập đủ thông tin");
      setLoadingModal(false);
      return;
    }
    if (
      resultData.length > 0 &&
      resultData
        .flatMap((item) =>
          item.children.flatMap((itemChild) => itemChild.title === ""),
        )
        .includes(true) &&
      lsGroupHeader.length > 0 &&
      checkEmpty
    ) {
      openNotificationWithIcon("error", "Lỗi", "Vui lòng nhập đủ thông tin");
      setLoadingModal(false);
      return;
    }

    // Check trùng Tiêu đề phần (Group Title)
    if (resultData.length > 0) {
      const groupTitles = resultData
        .map((group) => (group.title || "").trim().toLowerCase())
        .filter((t) => t !== "");
      const groupTitleSet = new Set();
      const duplicateGroupTitles = [];
      groupTitles.forEach((t) => {
        if (groupTitleSet.has(t)) {
          if (!duplicateGroupTitles.includes(t)) duplicateGroupTitles.push(t);
        } else {
          groupTitleSet.add(t);
        }
      });
      if (duplicateGroupTitles.length > 0) {
        openNotificationWithIcon(
          "error",
          "Cảnh báo",
          `Tiêu đề phần bị trùng: "${duplicateGroupTitles.join('", "')}". Vui lòng đặt tên phần khác nhau.`,
        );
        setLoadingModal(false);
        return;
      }
    }

    // Check trùng Tiêu đề trong các field của form
    if (resultData.length > 0) {
      const allTitles = resultData.flatMap((group) =>
        (group.children || [])
          .map((child) =>
            (child.title || "").replace(" (*)", "").trim().toLowerCase(),
          )
          .filter((t) => t !== ""),
      );
      const titleSet = new Set();
      const duplicateTitles = [];
      allTitles.forEach((t) => {
        if (titleSet.has(t)) {
          if (!duplicateTitles.includes(t)) duplicateTitles.push(t);
        } else {
          titleSet.add(t);
        }
      });
      if (duplicateTitles.length > 0) {
        openNotificationWithIcon(
          "error",
          "Cảnh báo",
          `Tiêu đề bị trùng: "${duplicateTitles.join('", "')}". Vui lòng đặt tên tiêu đề khác nhau.`,
        );
        setLoadingModal(false);
        return;
      }
    }

    let newResultData = {};
    newResultData.forms = cleanFormData(resultData);
    setLoadingModal(true);
    authAxios(cookies.get("token"))
      .get(listLoaiyeucauall, { params: {} })
      .then((res) => {
        waitForCreateInfo(
          values,
          res.data.results,
          listBophanxuly,
          newResultData,
          dataUser,
        )
          .then((res) => {
            if (res != false) {
              onCancelModal(true);
            }
            setLoadingModal(false);
          })
          .catch((err) => {
            openNotificationWithIcon("error", "Lỗi", err);
          });
      })
      .catch((err) => {});
  };
  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    console.log("cancel");
    setcurrentDataSource([]);
    setResultData([]);
    setCheckData(false);
    form.resetFields();
    onCancel(value);
    setLsGroupHeader([]);
  };

  const getResultData = (index, value, title, editTable, colorTitle) => {
    setCheckEmpty(false);
    // console.log('callback')
    let obj = {};
    let currentResultData = [];
    let children_obj = {};
    children_obj.title = title;
    // children_obj.is_editCell = editTable
    children_obj.editable = editTable;
    children_obj.colortitle = colorTitle;
    children_obj.children = value;
    if (resultData.length === 0) {
      currentResultData.push(children_obj);
      setResultData(currentResultData);
    } else {
      let newData = [...resultData];
      newData[index] = children_obj;
      setResultData(newData);
    }
  };

  const addGroupHeader = () => {
    const current = [...lsGroupHeader];
    // console.log(current)
    current.push({ title: "Phần dành cho Bộ phận yêu cầu" });
    // console.log(current)
    setLsGroupHeader(current);
  };
  const handleChangeOther = (info) => {
    let thisFileList = [...info.fileList];
    if (thisFileList.length > 0) {
      setSelectedFileOtherList([thisFileList[thisFileList.length - 1]]);
    }
    if (thisFileList.length === 0) {
      console.log("remove");
      setSelectedFileOther(null);
      setSelectedFileOtherList([]);
      form.setFieldsValue({
        filedinhkemkhac: undefined,
      });
    }
  };
  const Upload_File_Other = (file) => {
    // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    //     message.error(`${file.name} không phải là file excel`);
    // } else {
    console.log("ok");
    // this.setState({selectedFileOtherList: file.fileList});
    // this.setState({selectedFileOther: file});
    // }
  };
  const uploadOtherFileRequest = ({ file, onSuccess, data }) => {
    setTimeout(() => {
      onSuccess("ok");
      Upload_File_Other(file);
    }, 0);
  };
  return (
    <Modal
      title="Tạo loại yêu cầu mới"
      visible={visible}
      okText="Lưu"
      onOk={onOk}
      onCancel={onCancelModal}
      forceRender
      width="100%"
      bodyStyle={{ maxHeight: "75vh", overflowY: "auto" }}
    >
      <Spin
        spinning={loadingModal}
        tip="Đang tạo loại yêu cầu vui lòng đợi...."
      >
        <Form
          form={form}
          layout="vertical"
          name="userFormCreate"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ is_active: true }}
        >
          <Row>
            <Col sm={8} offset={1}>
              <Form.Item
                name="tenyeucau"
                label="Tên loại yêu cầu"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col sm={6} offset={1}>
              <Form.Item
                name="bophanxuly"
                label="Bộ phận xử lý"
                rules={[{ required: true }]}
              >
                <Select>
                  {listBophanxuly.map((item, index) => (
                    <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm={2} offset={1}>
              <Form.Item
                name="is_active"
                label="Kích hoạt"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
                {/* <Checkbox defaultChecked={true} checked={isActive} onChange={(e) => setActive(e)}/> */}
              </Form.Item>
            </Col>
            <Col sm={2} offset={1}>
              <br />
              <Button type={"primary"} onClick={() => addGroupHeader()}>
                <PlusCircleTwoTone />
                Thêm mới
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={22} sm={22} md={22} lg={8} xl={8} offset={1}>
              <Form.Item label="File đính kèm" name="filedinhkemkhac">
                <Upload
                  onChange={handleChangeOther}
                  fileList={selectedFileOtherList}
                  customRequest={uploadOtherFileRequest}
                  multiple
                >
                  <Button icon={<UploadOutlined />} htmlType="button">
                    Tải lên file hướng dẫn quy trình
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Row
            style={{
              maxHeight: "50vh",
              overflowY: "auto",
              overflowX: "hidden",
              marginRight: "-5px",
            }}
          >
            {checkData
              ? lsGroupHeader.length != 0 &&
                lsGroupHeader.map((item, index) => {
                  return (
                    <Row>
                      <div style={{ width: "100%", marginBottom: "5px" }}>
                        <CreateTable
                          dataSource={[]}
                          columns={currentColumnsCreate}
                          callBackfunction={(
                            value,
                            title,
                            editTable,
                            colorTitle,
                          ) =>
                            getResultData(
                              index,
                              value,
                              title,
                              editTable,
                              colorTitle,
                            )
                          }
                          title={item.title}
                          color={
                            index == 1
                              ? { r: "58", g: "113", b: "186", a: "1" }
                              : index == 2
                                ? { r: "151", g: "72", b: "6", a: "1" }
                                : { r: "0", g: "0", b: "0", a: "1" }
                          }
                          isEditing={true}
                          key={"create_" + index}
                          // formTitle= {
                          //     <Input placeholder={'Nhập tiêu đề'} value={"this.state.title"}/>
                          // }
                        />
                      </div>
                    </Row>
                  );
                })
              : null}
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

const ModalFormEdit = ({
  visible,
  onCancel,
  dataLoaiyeucauEdit,
  listBophanxuly,
  dataUser,
  dataCurrentForm,
}) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  const [checkNoDataForm, setCheckNoDataForm] = useState(false);
  const [resultData, setResultData] = useState([]);
  // const [currentDataSource, setcurrentDataSource] = useState([])
  const [checkData, setCheckData] = useState(true);
  const [checkEmpty, setCheckEmpty] = useState(true);
  const [selectedFileOtherList, setSelectedFileOtherList] = useState([]);
  const [selectedFileOther, setSelectedFileOther] = useState(null);
  const [lsGroupHeader, setLsGroupHeader] = useState([]);
  const [isEditingForm, setIsEditingForm] = useState(false);

  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onFinish = (values) => {
    // Kiểm tra khi dataCurrentForm trống HOẶC đang ở chế độ edit form
    if (dataCurrentForm.length == 0 || isEditingForm) {
      if (resultData.length === 0 && lsGroupHeader.length > 0 && !checkEmpty) {
        openNotificationWithIcon("error", "Lỗi", "Vui lòng nhập đủ thông tin");
        setLoadingModal(false);
        return;
      }
      if (
        resultData.length > 0 &&
        resultData
          .flatMap((item) =>
            item.children.flatMap((itemChild) => itemChild.title === ""),
          )
          .includes(true) &&
        lsGroupHeader.length > 0 &&
        checkEmpty
      ) {
        openNotificationWithIcon("error", "Lỗi", "Vui lòng nhập đủ thông tin");
        setLoadingModal(false);
        return;
      }
    }

    // Check trùng Tiêu đề phần (Group Title)
    if (resultData.length > 0) {
      const groupTitles = resultData
        .map((group) => (group.title || "").trim().toLowerCase())
        .filter((t) => t !== "");
      const groupTitleSet = new Set();
      const duplicateGroupTitles = [];
      groupTitles.forEach((t) => {
        if (groupTitleSet.has(t)) {
          if (!duplicateGroupTitles.includes(t)) duplicateGroupTitles.push(t);
        } else {
          groupTitleSet.add(t);
        }
      });
      if (duplicateGroupTitles.length > 0) {
        openNotificationWithIcon(
          "error",
          "Cảnh báo",
          `Tiêu đề phần bị trùng: "${duplicateGroupTitles.join('", "')}". Vui lòng đặt tên phần khác nhau.`,
        );
        setLoadingModal(false);
        return;
      }
    }

    // Check trùng Tiêu đề trong các field của form
    if (resultData.length > 0) {
      const allTitles = resultData.flatMap((group) =>
        (group.children || [])
          .map((child) =>
            (child.title || "").replace(" (*)", "").trim().toLowerCase(),
          )
          .filter((t) => t !== ""),
      );
      const titleSet = new Set();
      const duplicateTitles = [];
      allTitles.forEach((t) => {
        if (titleSet.has(t)) {
          if (!duplicateTitles.includes(t)) duplicateTitles.push(t);
        } else {
          titleSet.add(t);
        }
      });
      if (duplicateTitles.length > 0) {
        openNotificationWithIcon(
          "error",
          "Cảnh báo",
          `Tiêu đề bị trùng: "${duplicateTitles.join('", "')}". Vui lòng đặt tên tiêu đề khác nhau.`,
        );
        setLoadingModal(false);
        return;
      }
    }

    let newResultData = {};
    newResultData.forms = cleanFormData(resultData);

    // Nếu đang edit form template đã có sẵn thì gửi resultData,
    // nếu không edit form thì bỏ qua (giữ nguyên form cũ)
    const formDataToSend =
      (dataCurrentForm.length == 0 || isEditingForm) && resultData.length > 0
        ? newResultData
        : [];

    authAxios(cookies.get("token"))
      .get(listLoaiyeucauall, { params: {} })
      .then((res) => {
        waitForeditInfo(
          values,
          dataLoaiyeucauEdit,
          res.data.results,
          listBophanxuly,
          formDataToSend,
          dataUser,
          isEditingForm,
        )
          .then((res) => {
            if (res != false) {
              onCancelModal(true);
            }
            setLoadingModal(false);
          })
          .catch((err) => {
            openNotificationWithIcon("error", "Lỗi", err);
          });
      })
      .catch((err) => {});
  };

  useEffect(() => {
    form.setFieldsValue({
      tenyeucau: dataLoaiyeucauEdit.name,
      bophanxuly: dataLoaiyeucauEdit.handling_group,
      is_active: dataLoaiyeucauEdit.is_active,
    });
    setCheckData(true);
    // Reset trạng thái edit form mỗi khi mở modal với record mới
    setIsEditingForm(false);
    setResultData([]);
    setLsGroupHeader([]);
  }, [dataLoaiyeucauEdit]);

  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    setCheckData(false);
    setIsEditingForm(false);
    setResultData([]);
    form.resetFields();
    onCancel(value);
    setLsGroupHeader([]);
  };

  const getResultData = (index, value, title, editTable, colorTitle) => {
    setCheckEmpty(false);
    // console.log('callback')
    let currentResultData = [];
    let children_obj = {};
    children_obj.title = title;
    // children_obj.is_editCell = editTable
    children_obj.editable = editTable;
    children_obj.colortitle = colorTitle;
    children_obj.children = value;

    if (resultData.length === 0) {
      currentResultData.push(children_obj);
      setResultData(currentResultData);
    } else {
      let newData = [...resultData];
      newData[index] = children_obj;
      setResultData(newData);
    }
  };

  const handleChangeOther = (info) => {
    let thisFileList = [...info.fileList];
    if (thisFileList.length > 0) {
      setSelectedFileOtherList([thisFileList[thisFileList.length - 1]]);
    }
    if (thisFileList.length === 0) {
      setSelectedFileOther(null);
      setSelectedFileOtherList([]);
      form.setFieldsValue({
        filedinhkemkhac: undefined,
      });
    }
  };
  const Upload_File_Other = (file) => {
    console.log("ok");
  };

  const uploadOtherFileRequest = ({ file, onSuccess, data }) => {
    setTimeout(() => {
      onSuccess("ok");
      Upload_File_Other(file);
    }, 0);
  };

  const addGroupHeader = () => {
    const current = [...lsGroupHeader];
    current.push({ title: "Phần dành cho Bộ phận yêu cầu" });
    setLsGroupHeader(current);
  };

  const startEditForm = () => {
    // Khởi tạo lsGroupHeader từ dataCurrentForm để render đúng số CreateTable
    const headers = dataCurrentForm.map((item) => ({ title: item.title }));
    setLsGroupHeader(headers);
    // Chuẩn hóa title: đảm bảo có (*) nếu required=true, bỏ (*) nếu required=false
    const processedData = dataCurrentForm.map((item) => ({
      ...item,
      children: item.children.map((child) => {
        const base = (child.title || "").replace(" (*)", "");
        const normalizedTitle = child.required === true ? `${base} (*)` : base;

        let normalizedOption = child.option;
        if (Array.isArray(normalizedOption)) {
          normalizedOption = normalizedOption
            .map((v) => (Array.isArray(v) ? v[1] : v))
            .filter((v) => v !== undefined && v !== "");
        }

        return { ...child, title: normalizedTitle, option: normalizedOption };
      }),
    }));
    setResultData(processedData);
    setIsEditingForm(true);
  };

  const cancelEditForm = () => {
    setIsEditingForm(false);
    setResultData([]);
    setLsGroupHeader([]);
  };

  return (
    <Modal
      title="Chỉnh sửa thông tin loại yêu cầu"
      visible={visible}
      okText="Lưu"
      onOk={onOk}
      onCancel={onCancelModal}
      forceRender
      width="100%"
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormEdit"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ is_active: dataLoaiyeucauEdit.is_active }}
        >
          <Row>
            <Col sm={12} offset={1}>
              <Form.Item
                name="tenyeucau"
                label="Tên yêu cầu"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col sm={6} offset={1}>
              <Form.Item
                name="bophanxuly"
                label="Bộ phận xử lý"
                rules={[{ required: true }]}
              >
                <Select>
                  {listBophanxuly.map((item, index) => (
                    <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm={2} offset={1}>
              <Form.Item
                name="is_active"
                label="Kích hoạt"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
            </Col>
            {dataCurrentForm.length == 0 ? (
              <Col sm={2} offset={1}>
                <br />
                <Button type={"primary"} onClick={() => addGroupHeader()}>
                  <PlusCircleTwoTone />
                  Thêm mới
                </Button>
              </Col>
            ) : (
              <Col
                sm={5}
                offset={1}
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "flex-end",
                  paddingBottom: "4px",
                }}
              >
                {!isEditingForm ? (
                  <Button
                    type={"default"}
                    onClick={startEditForm}
                    icon={<EditFilled />}
                  >
                    Chỉnh sửa form
                  </Button>
                ) : (
                  <>
                    <Button type={"primary"} onClick={() => addGroupHeader()}>
                      <PlusCircleTwoTone />
                      Thêm mới
                    </Button>
                    <Button danger onClick={cancelEditForm}>
                      Hủy chỉnh sửa
                    </Button>
                  </>
                )}
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={22} sm={22} md={22} lg={22} xl={22} offset={1}>
              <Form.Item label="File đính kèm" name="filedinhkemkhac">
                <Upload
                  onChange={handleChangeOther}
                  fileList={selectedFileOtherList}
                  customRequest={uploadOtherFileRequest}
                  multiple
                >
                  <Button icon={<UploadOutlined />} htmlType="button">
                    Tải lên file hướng dẫn quy trình
                  </Button>
                </Upload>
              </Form.Item>
              <a href={dataLoaiyeucauEdit.attachment_file} target={"_blank"}>
                Tài liệu hướng dẫn
              </a>
            </Col>
          </Row>
          <Row
            style={{
              maxHeight: "50vh",
              overflowY: "auto",
              overflowX: "hidden",
              marginRight: "-5px",
            }}
          >
            {checkData
              ? dataCurrentForm.length > 0 && !isEditingForm
                ? // Chế độ xem (view) khi không edit
                  dataCurrentForm.map((item, index) => {
                    return (
                      <Row key={index}>
                        <Col sm={23} offset={1}>
                          <Table
                            components={null}
                            rowClassName={() => "editable-row"}
                            bordered
                            dataSource={item.children}
                            columns={currentColumnsView}
                            scroll={{ x: "100%", y: 300 }}
                            pagination={false}
                            style={{ marginBottom: "10px" }}
                            size="small"
                            title={() => (
                              <Row>
                                <Col
                                  span={21}
                                  style={{
                                    marginLeft: "16px",
                                    color: item.colortitle,
                                  }}
                                >
                                  {item.title}
                                </Col>
                                <Col span={1} offset={1}>
                                  <Tooltip
                                    placement="topLeft"
                                    title={
                                      'Tích "Khóa" đối với phần được truy cập theo bộ phận'
                                    }
                                  >
                                    <Checkbox
                                      value="true"
                                      checked={!item.editable}
                                      style={{ marginTop: "5px" }}
                                      disabled
                                    >
                                      Khóa
                                    </Checkbox>
                                  </Tooltip>
                                </Col>
                              </Row>
                            )}
                          />
                        </Col>
                      </Row>
                    );
                  })
                : // Chế độ edit form (khi isEditingForm=true hoặc chưa có dataCurrentForm)
                  lsGroupHeader.length != 0 &&
                  lsGroupHeader.map((item, index) => {
                    // Lấy dữ liệu hiện có của nhóm tương ứng (nếu đang edit form cũ)
                    const existingGroupData =
                      isEditingForm && dataCurrentForm[index]
                        ? dataCurrentForm[index].children
                        : [];
                    return (
                      <Row key={"edit_" + index}>
                        <div style={{ width: "100%", marginBottom: "5px" }}>
                          <CreateTable
                            dataSource={existingGroupData}
                            columns={currentColumnsCreate}
                            callBackfunction={(
                              value,
                              title,
                              editTable,
                              colorTitle,
                            ) =>
                              getResultData(
                                index,
                                value,
                                title,
                                editTable,
                                colorTitle,
                              )
                            }
                            title={item.title}
                            color={
                              isEditingForm && dataCurrentForm[index]
                                ? (() => {
                                    // Parse màu từ chuỗi rgba nếu có
                                    const c = dataCurrentForm[index].colortitle;
                                    if (c && c.startsWith("rgba(")) {
                                      const m = c.match(
                                        /rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/,
                                      );
                                      if (m)
                                        return {
                                          r: m[1],
                                          g: m[2],
                                          b: m[3],
                                          a: m[4],
                                        };
                                    }
                                    return index == 1
                                      ? { r: "58", g: "113", b: "186", a: "1" }
                                      : index == 2
                                        ? { r: "151", g: "72", b: "6", a: "1" }
                                        : { r: "0", g: "0", b: "0", a: "1" };
                                  })()
                                : index == 1
                                  ? { r: "58", g: "113", b: "186", a: "1" }
                                  : index == 2
                                    ? { r: "151", g: "72", b: "6", a: "1" }
                                    : { r: "0", g: "0", b: "0", a: "1" }
                            }
                            isEditing={true}
                            initialEditTable={
                              isEditingForm &&
                              dataCurrentForm[index] !== undefined
                                ? dataCurrentForm[index].editable
                                : true
                            }
                            key={(isEditingForm ? "edit_" : "create_") + index}
                          />
                        </div>
                      </Row>
                    );
                  })
              : null}
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

class SettingsLoaiyeucau extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    total_page: "",
    pagination: { pageSize: 10 },
    visibleFormEditLoaiyeucauModal: false,
    idLoaiyeucauEdit: "",
    dataLoaiyeucauEdit: "",
    listBophanxuly: [],
    dataCurrentForm: [],
  };
  componentDidMount() {
    // this.setState({loading: true});
    this.fetchListLoaiyeucau({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "name",
      typeSort: "descend",
    });
    this.fetchListBophanxuly();
    this.handleFetchUserInfo()
      .then((res) => {
        this.setState({
          dataUser: res.data.infoUser,
        });
      })
      .catch((err) => {
        this.setState({ error: err });
      });
  }
  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
    });
    this.fetchListLoaiyeucau({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      search: this.state.searchKey,
      ...filters,
    });
  };
  handleFetchUserInfo = () => {
    return authAxios(cookies.get("token")).get(userIDURL);
  };

  fetchListBophanxuly() {
    authAxios(cookies.get("token"))
      .get(listBophanxuly, {
        params: { is_active: true, page_size: "1000", page: "1" },
      })
      .then((res) => {
        this.setState({ listBophanxuly: res.data.results, loading: false });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }
  fetchListLoaiyeucau = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(listLoaiyeucauall, { params: params })
      .then((res) => {
        this.setState({
          data: res.data.results,
          loading: false,
          total_page: res.data.count,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  SearchList = (value, event) => {
    let { sortKey, sortDirection, pageSize } = this.state;
    const pager = { ...this.state.pagination };
    pager.current = 1;
    pager.page = 1;
    this.setState({ searchKey: value, pagination: pager });
    this.fetchListLoaiyeucau({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "name",
      typeSort: "ascend",
      search: value,
    });
  };
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  cleanData = (values) => {
    try {
      let dataSource = [];
      let i = 0;
      for (const itemValue in values) {
        if (
          !values[itemValue].title === undefined ||
          !values[itemValue].children ||
          values[itemValue].children.length === 0
        ) {
          openNotificationWithIcon(
            "error",
            "Lỗi",
            "Dữ liệu form mẫu có vấn đề, vui lòng kiểm tra lại.",
          );
          this.setState({
            dataCurrentForm: [],
          });
        }

        let itemData = [];
        for (const obj_item in values[itemValue].children) {
          let obj_data = {};
          const item = values[itemValue].children[obj_item];

          obj_data.key = i;
          obj_data.type = item.type;
          obj_data.editable = item.editable;
          obj_data.title = item.title;
          obj_data.required = item.required;
          obj_data.handling = item.handling;
          obj_data.status = item.status; //120925
          obj_data.validate = item.validate;
          obj_data.option =
            item.option != undefined ? Object.entries(item.option) : "";
          obj_data.widthcol = item.widthcol;
          obj_data.fixed = item.fixed;
          itemData.push(obj_data);
          i += 1;
        }
        let children_obj = {};
        children_obj.title = values[itemValue].title;
        children_obj.editable = values[itemValue].editable;
        children_obj.colortitle = values[itemValue].colortitle;
        children_obj.children = itemData;
        dataSource.push(children_obj);
      }

      if (dataSource.length === 0) {
        openNotificationWithIcon(
          "warning",
          "Cảnh báo",
          "Dữ liệu form mẫu trống.",
        );
        this.setState({
          dataCurrentForm: [],
        });
      }
      this.setState({
        dataCurrentForm: dataSource,
      });
    } catch (err) {
      console.log(err);
      openNotificationWithIcon(
        "error",
        "Lỗi",
        "Dữ liệu form mẫu có vấn đề, vui lòng kiểm tra lại",
      );
      this.setState({
        dataCurrentForm: [],
      });
    }
  };

  getValue_IDLoaiyeucau = (value) => {
    authAxios(cookies.get("token"))
      .get(getLoaiyeucauFormURL(value))
      .then((res) => {
        // console.log(res.data);
        if (res.data.message === "The ticket type template does not exist") {
          // setCheckNoDataForm(false)
          this.setState({
            dataCurrentForm: [],
          });
        } else {
          // setCheckNoDataForm(true)
          this.cleanData(res.data.forms);
        }
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon("error", "Lỗi", err);
      });
  };

  editInfo = (id) => {
    this.getValue_IDLoaiyeucau(id);
    waitForLoaiyeucauInfo(id).then((res) => {
      this.setState({
        idBophanEdit: id,
        dataLoaiyeucauEdit: res.data,
        // listTeam:res[1].data,
        visibleFormEditModal: true,
      });
    });
  };
  showCreateModal = () => {
    this.setState({ visibleFormCreateModal: true });
  };

  hideEditModal = (value) => {
    this.setState({ visibleFormEditModal: false, dataCurrentForm: [] });
    // this.setState({idBophanEdit: '', visibleFormEditModal: false,dataLoaiyeucauEdit:''})
    if (value === true) {
      this.fetchListLoaiyeucau({
        page_size: this.state.pagination.pageSize,
        page: this.state.pagination.current,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon(
        "success",
        "Thành công",
        "Cập nhật thông tin loại yêu cầu ",
      );
    }
  };

  hideCreateModal = (value) => {
    this.setState({ visibleFormCreateModal: false });
    if (value === true) {
      this.fetchListLoaiyeucau({
        page_size: this.state.pagination.pageSize,
        page: this.state.pagination.current,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon("success", "Thành công", "Tạo mới loại yêu cầu");
    }
  };

  render() {
    let {
      loading,
      data,
      total_page,
      pagination,
      visibleFormEditModal,
      visibleFormCreateModal,
    } = this.state;

    const columns = [
      {
        title: "STT",
        dataIndex: "id",
        key: "index",
        render: (value, item, index) =>
          ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
        sorter: (a, b) => a.id - b.id,
        sortDirections: ["descend", "ascend", "descend"],
      },
      {
        title: "Loại yêu cầu",
        dataIndex: "name",
        key: "name",
        sorter: (a) => a,
      },
      {
        title: "Bộ phận xử lý",
        dataIndex: "handling_group_name",
        key: "handling_group_name",
        sorter: (a) => a,
      },
      {
        title: "Trạng thái",
        dataIndex: "is_active",
        key: "is_active",
        render: (text) => (text ? "Kích hoạt" : "Khóa"),
      },
      {
        title: "Thao tác",
        key: "operation",
        render: (text, record) => (
          <Space size="middle">
            <Tooltip
              placement="bottomRight"
              title={"Chỉnh sửa thông tin bộ phận sử dụng"}
            >
              <Button onClick={() => this.editInfo(record.id)} type={"primary"}>
                <EditFilled />
              </Button>
            </Tooltip>
          </Space>
        ),
      },
    ];
    return (
      <>
        <Row>
          <Col sm={14} style={{ float: "left" }}>
            <Button
              type={"danger"}
              style={{ marginBottom: 15 }}
              onClick={this.showCreateModal}
            >
              <PlusOutlined /> Thêm loại yêu cầu mới
            </Button>
          </Col>
          <Col sm={10} style={{ float: "right" }}>
            <Search
              placeholder="Nhập từ khóa tìm kiếm"
              enterButton="Tìm kiếm"
              size="normal"
              onSearch={this.SearchList}
            />
          </Col>
        </Row>
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          rowKey="id"
          onChange={this.handleChange}
          pagination={{
            current: this.state.pagination.current,
            pageSize: this.state.pagination.pageSize,
            total: total_page,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
        <ModalFormEdit
          visible={visibleFormEditModal}
          onCancel={this.hideEditModal}
          dataLoaiyeucauEdit={this.state.dataLoaiyeucauEdit}
          listBophanxuly={this.state.listBophanxuly}
          dataUser={this.state.dataUser}
          dataCurrentForm={this.state.dataCurrentForm}
        />
        <ModalFormCreate
          visible={visibleFormCreateModal}
          onCancel={this.hideCreateModal}
          listBophanxuly={this.state.listBophanxuly}
          dataUser={this.state.dataUser}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};
export default connect(mapStateToProps)(SettingsLoaiyeucau);
